import splitSignup from './split-signup/split-signup.vue';
import ProjectService from '../../project.service.js';
import Service from '@/service/index.js';
import {successMessage, errorMessage } from '@/utils/message.js';
import AssetsInfo from '@/components/assets-info/assets-info.vue';
import QrCodePage from '@/components/qr-code/index.vue';

const debounce = require('lodash.debounce');
export default {
  components: {
    splitSignup,
    ProjectService,
    AssetsInfo,
    QrCodePage
  },
  data() {
    return {
      // type: 2,
      // showOther: false,
      id: '',
      signInfo: [], // 受让人集合
      userType: null, // 用户类型
      projectInfo: null, // 流转的基本信息
      projectStatus: null, // 按钮状态
      contractStatus: null, // 状态
      qrCodeVisible: false,
      projectId: ''
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getDictList();
  },
  computed: {
    // otherImage(){
    //   return this.showOther === false ? require('@/assets/images/transaction/double_right1.png') : require('@/assets/images/transaction/double_right.png');
    // }
  },
  mounted() {
    // 获取项目详情的基本信息 用来判断是拆分还是整体
    this.getProjectDetail();
    // 获取列表
    this.selectDealResults();
  },
  methods: {
    // 收不到签约短信
    qrCodeClick(projectId) {
      console.log(3333);
      this.projectId = projectId;
      this.qrCodeVisible = true;
    },
    // 获取用户类型 字典查询
    getDictList () {
      const obj = {
        ECONOMIC_MEMBER_TYPE: 'userType',
        PROJECT_STATUS: 'projectStatus',
        PROJECT_BID_STATUS: 'contractStatus'
      };
      Object.keys(obj).forEach((key) => {
        Service.getSelectList(key).then(res => {
          if (res && res.code === '0') {
            this[obj[key]] = res.data;
          }
        });
      });
    },
    // 获取基本信息
    getProjectDetail () {
      const obj = {
        PROJECT: 'projectInfo'
      };
      Object.keys(obj).forEach(key => {
        ProjectService.getRollOutProjectDetail({
          projectId: this.id,
          echoCode: key
        }).then(res => {
          this[obj[key]] = res && res.data;
        });
      });
    },
    // 拆分 查看详情
    go_down(item, index) {
      this.$set(this.signInfo[index], 'showOther', !this.signInfo[index].showOther);
    },
    getBidInfo (item) {
      const lands = item && item.projectAssetsResForms || [];
      const bidInfo = {detail: []};
      bidInfo.detail = lands.map(item => {
        item.assetsInfo = JSON.stringify(item);
        item.bidCode = item.bidCode;
        return item;
      });
      return bidInfo;
    },
    // 获取处理列表集合
    selectDealResults () {
      ProjectService.selectDealResults(this.id).then(res => {
        if (res && res.code === '0') {
          this.signInfo = res.data;
          this.signInfo = res.data.map(item => ({
            ...item,
            showOther: false
          }));
        }
      });
    },
    // 审核成交人
    checkIdeal: debounce(function(userId, projectId, winningBidderId, bidId) {
      this.$router.push({name: 'checkidealpeople', query: {id: this.id, userId: userId, projectId: projectId, winningBidderId: winningBidderId, bidId: bidId}});
    }, 100),
    // 创建合同
    goCreatContract: debounce(function(userId, projectType, projectSubType) {
      this.$router.push({name: 'creatcontract', query: {id: this.id, userId: userId, projectType: projectType, projectSubType: projectSubType, type: '1'}});
    }, 100),
    // 下载合同
    dowmContract: debounce(function(projectType, projectSubType) {
      ProjectService.downloadContractDemo(projectType, projectSubType, this.$route.query.tradeType).then(res => {
        if (res && res.code === '0') {
          successMessage('合同下载成功');
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = 'data:file/doc;base64,' + res.data;
          link.download = '产权交易合同.doc';
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link.href);
        } else if (res && res.reason) {
          errorMessage(res && res.reason);
        } else {
          errorMessage('合同下载失败');
        }
      });
    }, 2000, {
      'leading': true,
      'trailing': false
    }),
    // 申请签署合同
    applySign: debounce(function(projectType, userId) {
      let params = {
        projectType: projectType,
        userId: userId,
        projectId: this.id
      };
      ProjectService.applySignContract(params).then(res => {
        if (res && res.code === '0') {
          successMessage('发送签约短信成功');
        } else if(res && res.reason){
          errorMessage(res && res.reason);
        }
      });
    }, 2000)
  }
};
